/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import React from "react";
import { Formik, Form, ErrorMessage } from "formik";
import {
  PrimaryButton,
  DefaultButton,
  Dialog,
  DialogType,
  DialogFooter,
  TextField,
} from "@fluentui/react";
import useAxios from "axios-hooks";
import Toast from "../../../Forms/Toast";
import Select from "react-select";
import FeatureSummary from "../../../Util/FeatureSummary";

const DeactivateCobrand = () => {
  const [showToast, setShowToast] = React.useState(false);
  const [showModal, setShowModal] = React.useState(false);
  const [confirmationText, setConfirmationText] = React.useState("");
  const [selectedCobrandName, setSelectedCobrandName] = React.useState("");
  const [pendingValues, setPendingValues] = React.useState(null);
  const [formikResetForm, setFormikResetForm] = React.useState(null);
  
  const [{ data, loading }, refetchCobrands] = useAxios({ url: `/internal/cobrands` });
  const cobrandOptions = data && data.map((cobrand) => ({ value: cobrand.cobrandId, label: cobrand.name }));

  const [{ submitData, loading: submitting, error: submitError }, submitForm] = useAxios(
    { url: `/internal/cobrand/deactivate/` },
    { manual: true },
  );

  const handleSubmit = async (values) => {
    const selectedCobrand = cobrandOptions?.find(option => option.value === values.cobrandId);
    setSelectedCobrandName(selectedCobrand?.label || "");
    setPendingValues(values);
    setConfirmationText("");
    setShowModal(true);
  };

  const handleConfirmDeactivation = async () => {
    if (confirmationText !== selectedCobrandName) {
      return;
    }

    try {
      const result = await submitForm({
        url: `/internal/cobrand/deactivate/${pendingValues.cobrandId}`,
        method: 'POST',
      });
      if (!result.isAxiosError) {
        setShowToast(true);
        setShowModal(false);
        setConfirmationText("");
        await refetchCobrands();
        if (formikResetForm) {
          formikResetForm();
        }
      }
    } catch (error) {
      console.error("Form submission failed:", error);
    }
  };

  const handleCancelModal = () => {
    setShowModal(false);
    setConfirmationText("");
    setPendingValues(null);
  };

  return (
    <Formik
      initialValues={{
        cobrandId: null
      }}
      onSubmit={handleSubmit}
    >
      {({ values, setFieldValue, resetForm }) => {
        if (!formikResetForm) {
          setFormikResetForm(() => resetForm);
        }
        
        return (
        <Form style={{width:400}}>
          <h4>Select Cobrand</h4>
          <Select
                options={cobrandOptions}
                onChange={(option) => { setFieldValue("cobrandId", option?.value) }}
                value={cobrandOptions?.find((option) => option.value === values.cobrandId)}
                placeholder="Select a cobrand"
                isSearchable
                className="mb10"
            />
          <PrimaryButton type="submit" text="Deactivate Cobrand" style={{ marginTop: "20px" }} disabled={!values.cobrandId} />
          <Toast show={showToast} message="Cobrand Deactivated" onClose={()=>setShowToast(false)}/>
          <FeatureSummary
              label="About Deactivate Cobrand"
              summary="Permanently deactivate a cobrand. Select the cobrand from the dropdown and confirm by typing the exact cobrand name. This action cannot be undone."
          />
          
          <Dialog
            hidden={!showModal}
            onDismiss={handleCancelModal}
            dialogContentProps={{
              type: DialogType.normal,
              title: 'Confirm Deactivation',
              subText: `To confirm deactivation, please type the cobrand name: "${selectedCobrandName}"`
            }}
            modalProps={{
              isBlocking: true
            }}
          >
            <TextField
              placeholder={`Type "${selectedCobrandName}" to confirm`}
              value={confirmationText}
              onChange={(e, newValue) => setConfirmationText(newValue || "")}
            />
            <DialogFooter>
              <PrimaryButton 
                onClick={handleConfirmDeactivation} 
                text="Deactivate" 
                disabled={confirmationText !== selectedCobrandName || submitting}
              />
              <DefaultButton onClick={handleCancelModal} text="Cancel" />
            </DialogFooter>
          </Dialog>
        </Form>
        );
      }}
    </Formik>
  );
};

export default DeactivateCobrand;
